import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import getMemberTasks, { GetMemberTasksParams } from './useMemberTasks.request';

import { Task } from 'modules/Tasks/types';

export const MEMBER_TASKS_QUERY_KEY = ['memberTasks'] as const;

export default function useMemberTasks<TData = Task[]>(
    params: GetMemberTasksParams = {},
    options?: Omit<UseQueryOptions<Task[], AxiosError, TData>, 'queryKey' | 'queryFn'>
) {
    return useQuery({
        queryKey: [...MEMBER_TASKS_QUERY_KEY, params],
        queryFn: () => getMemberTasks(params),
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        ...options,
    });
}
